// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This style file is imported by Navbar.js which is called by CsVersionPage.js file, ServiceInventoryPage.js file, PltVersionPage.js file.
*/

body {
  margin: 0;
  padding: 0;
}

.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 0%;
  padding-right: 0.8%;
  padding-top: 1%;
  padding-bottom: 1%;
  margin-right: 1%;
  margin-left: 5%;
  background-color: #0C3135;
  color: #fff;
  position: fixed;
  width: 93%;
  z-index: 10; 
  border-radius: 18px;
}

.app-name {
  font-weight: bold;
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.navbar-right {
  display: flex;
  align-items: center;
  gap: 12px;
}


.navbar button {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
}

/* Rest of the CSS remains the same */
.navbar button:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.navbar button.active {
  background: rgba(255, 255, 255, 0.25);
  border: 2px solid rgba(255, 255, 255, 0.5);
}

.navbar button svg {
  width: 20px;
  height: 20px;
}

.navbar button::before {
  content: attr(data-tooltip);
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 8px;
  padding: 5px 10px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  border-radius: 4px;
  font-size: 12px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  white-space: nowrap;
  z-index: 1000;
}

.navbar button::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent rgba(0, 0, 0, 0.8) transparent;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.navbar button:hover::before,
.navbar button:hover::after {
  opacity: 1;
  visibility: visible;
}

@media (max-width: 321px) {
  .navbar {
    width: 100%;
    padding: 10px;
    border-radius: 0;
    margin: 0;
    height:5vh;
  }

  .app-name {
    font-size: 10px;
    left:30%;
  }
}

@media (min-width: 321px) and (max-width: 376px)  {
  .navbar {
    width: 100%;
    padding: 10px;
    border-radius: 0;
    margin: 0;
    height:5vh;
  }

  .app-name {
    font-size: 16px;
    left:30%;
  }
}

@media  (min-width: 376px) and (max-width: 426px)  {
  .navbar {
    width: 100%;
    padding: 10px;
    border-radius: 0;
    margin: 0;
    height:5vh;
  }

  .app-name {
    font-size: 16px;
    left:30%;
  }
}

@media (min-width: 426px) and (max-width: 769px) {
  .navbar {
    width: 100%;
    padding: 10px;
    border-radius: 0;
    margin: 0;
  }

  .app-name {
    font-size: 16px;
  }

  .navbar-right {
    gap: 8px;
  }

  .navbar button {
    width: 35px;
    height: 35px;
    font-size: 1rem;
  }
}

@media (min-width: 769px) and (max-width: 1025px) {
  .navbar {
    width: 92%;
    padding: 10px;
    border-radius: 0;
    margin: 0;
    margin-left:5%;
    margin-right: 5%;
    border-radius: 16px;
  }
  .app-name {
    font-size: 16px;
  }
  .navbar-right {
    gap: 8px;
  }
  .navbar button {
    width: 35px;
    height: 35px;
    font-size: 1rem;
  }
}

@media (min-width: 1025px) and (max-width: 1441px) {
  .navbar {
    width: 92%;
    height:5vh;
    padding: 10px;
    border-radius: 0;
    margin: 0;
    margin-left:5%;
    margin-right: 5%;
    border-radius: 16px;
  }
  .app-name {
    font-size: 16px;
  }
  .navbar-right {
    gap: 8px;
  }
  .navbar button {
    width: 35px;
    height: 35px;
    font-size: 1rem;
  }
}


@media (min-width: 1921px){
  .navbar {
    width: 92%;
    height:4vh;
    padding: 10px;
    border-radius: 0;
    margin: 0;
    margin-left:5%;
    margin-right: 5%;
    border-radius: 16px;
  }
  .app-name {
    font-size: 22px;
  }
  .navbar-right {
    gap: 8px;
    font-size: 22px;
  }
  .navbar button {
    width: 35px;
    height: 35px;
    font-size: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/NavBar/Navbar.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,oEAAoE;EACpE,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;AACF;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;AACF;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;AACF;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,QAAQ;EACV;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,QAAQ;EACV;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;;AAGA;EACE;IACE,UAAU;IACV,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,QAAQ;IACR,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":["/*\nThis style file is imported by Navbar.js which is called by CsVersionPage.js file, ServiceInventoryPage.js file, PltVersionPage.js file.\n*/\n\nbody {\n  margin: 0;\n  padding: 0;\n}\n\n.navbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 0%;\n  padding-right: 0.8%;\n  padding-top: 1%;\n  padding-bottom: 1%;\n  margin-right: 1%;\n  margin-left: 5%;\n  background-color: #0C3135;\n  color: #fff;\n  position: fixed;\n  width: 93%;\n  z-index: 10; \n  border-radius: 18px;\n}\n\n.app-name {\n  font-weight: bold;\n  font-family: 'Poppins', sans-serif;\n  font-size: 18px;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.navbar-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n\n.navbar button {\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.2rem;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  position: relative;\n}\n\n/* Rest of the CSS remains the same */\n.navbar button:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.navbar button.active {\n  background: rgba(255, 255, 255, 0.25);\n  border: 2px solid rgba(255, 255, 255, 0.5);\n}\n\n.navbar button svg {\n  width: 20px;\n  height: 20px;\n}\n\n.navbar button::before {\n  content: attr(data-tooltip);\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-top: 8px;\n  padding: 5px 10px;\n  background: rgba(0, 0, 0, 0.8);\n  color: white;\n  border-radius: 4px;\n  font-size: 12px;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  z-index: 1000;\n}\n\n.navbar button::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border-width: 5px;\n  border-style: solid;\n  border-color: transparent transparent rgba(0, 0, 0, 0.8) transparent;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n}\n\n.navbar button:hover::before,\n.navbar button:hover::after {\n  opacity: 1;\n  visibility: visible;\n}\n\n@media (max-width: 321px) {\n  .navbar {\n    width: 100%;\n    padding: 10px;\n    border-radius: 0;\n    margin: 0;\n    height:5vh;\n  }\n\n  .app-name {\n    font-size: 10px;\n    left:30%;\n  }\n}\n\n@media (min-width: 321px) and (max-width: 376px)  {\n  .navbar {\n    width: 100%;\n    padding: 10px;\n    border-radius: 0;\n    margin: 0;\n    height:5vh;\n  }\n\n  .app-name {\n    font-size: 16px;\n    left:30%;\n  }\n}\n\n@media  (min-width: 376px) and (max-width: 426px)  {\n  .navbar {\n    width: 100%;\n    padding: 10px;\n    border-radius: 0;\n    margin: 0;\n    height:5vh;\n  }\n\n  .app-name {\n    font-size: 16px;\n    left:30%;\n  }\n}\n\n@media (min-width: 426px) and (max-width: 769px) {\n  .navbar {\n    width: 100%;\n    padding: 10px;\n    border-radius: 0;\n    margin: 0;\n  }\n\n  .app-name {\n    font-size: 16px;\n  }\n\n  .navbar-right {\n    gap: 8px;\n  }\n\n  .navbar button {\n    width: 35px;\n    height: 35px;\n    font-size: 1rem;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1025px) {\n  .navbar {\n    width: 92%;\n    padding: 10px;\n    border-radius: 0;\n    margin: 0;\n    margin-left:5%;\n    margin-right: 5%;\n    border-radius: 16px;\n  }\n  .app-name {\n    font-size: 16px;\n  }\n  .navbar-right {\n    gap: 8px;\n  }\n  .navbar button {\n    width: 35px;\n    height: 35px;\n    font-size: 1rem;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1441px) {\n  .navbar {\n    width: 92%;\n    height:5vh;\n    padding: 10px;\n    border-radius: 0;\n    margin: 0;\n    margin-left:5%;\n    margin-right: 5%;\n    border-radius: 16px;\n  }\n  .app-name {\n    font-size: 16px;\n  }\n  .navbar-right {\n    gap: 8px;\n  }\n  .navbar button {\n    width: 35px;\n    height: 35px;\n    font-size: 1rem;\n  }\n}\n\n\n@media (min-width: 1921px){\n  .navbar {\n    width: 92%;\n    height:4vh;\n    padding: 10px;\n    border-radius: 0;\n    margin: 0;\n    margin-left:5%;\n    margin-right: 5%;\n    border-radius: 16px;\n  }\n  .app-name {\n    font-size: 22px;\n  }\n  .navbar-right {\n    gap: 8px;\n    font-size: 22px;\n  }\n  .navbar button {\n    width: 35px;\n    height: 35px;\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
